module.exports = __webpack_public_path__ + "img/item7-3.f2b7ec8b.png";